import { View, Text, Pressable } from 'react-native';
import {
  wordleKeyboardStyles as styles,
  wordleKeyFaceStyles,
  wordleKeyLedgeStyles,
  wordleKeyTextStyles,
  type WordleKeyState,
} from './WordleKeyboard.styles';
import {
  WORDLE_KEYBOARD_ROWS,
  KEY_ENTER,
  KEY_DEL,
  type WordleMark,
} from '../../../src/quiz/constants/warmup.constants';

interface WordleKeyboardProps {
  keyStates: Record<string, WordleMark>;
  disabled: boolean;
  onKeyPress: (key: string) => void;
  onEnter: () => void;
  onDelete: () => void;
}

function keyStateFor(label: string, state: WordleMark | undefined): WordleKeyState {
  if (label === KEY_ENTER || label === KEY_DEL) return 'action';
  if (state) return state;
  return 'default';
}

export function WordleKeyboard({ keyStates, disabled, onKeyPress, onEnter, onDelete }: WordleKeyboardProps) {
  const handlePress = (label: string) => {
    if (disabled) return;
    if (label === KEY_ENTER) return onEnter();
    if (label === KEY_DEL) return onDelete();
    return onKeyPress(label);
  };

  return (
    <View style={styles.container}>
      {WORDLE_KEYBOARD_ROWS.map((row, rIndex) => (
        <View key={`kbrow-${rIndex}`} style={styles.row}>
          {row.map((label) => {
            const isAction = label === KEY_ENTER || label === KEY_DEL;
            const keyState = keyStateFor(label, keyStates[label]);
            return (
              <Pressable
                key={label}
                onPress={() => handlePress(label)}
                style={({ pressed }) => [
                  styles.keyOuter,
                  isAction && styles.keyOuterAction,
                  wordleKeyLedgeStyles[keyState],
                  pressed && styles.pressed,
                ]}
              >
                <View style={[styles.keyFace, wordleKeyFaceStyles[keyState]]}>
                  <Text style={[styles.keyText, isAction && styles.keyTextAction, wordleKeyTextStyles[keyState]]}>
                    {label === KEY_DEL ? '⌫' : label}
                  </Text>
                </View>
              </Pressable>
            );
          })}
        </View>
      ))}
    </View>
  );
}
